module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing"
  }, [_c('div', {
    staticClass: "landing__container"
  }, [_c('div', {
    ref: "logo",
    staticClass: "landing__logo"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('logo', {
    ref: "logo",
    attrs: {
      "alt": "logo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    ref: "title",
    staticClass: "landing__title"
  }, [_c('p', [_vm._v("Hello!")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "landing__subtitle"
  }, [_vm._m(0)])]), _vm._v(" "), _c('button', {
    ref: "button",
    staticClass: "landing__button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.readyClicked
    }
  }, [_c('span', [_vm._v("I'm Ready")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Ready to reconnect"), _c('br'), _vm._v(" the whole family?")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab524ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/3-pages/Landing.vue
// module id = 535
// module chunks = 1